<div class="contains-button">
   <!-- Hiển thị tiêu đề mở rộng -->
   <div class="editor-header" *ngIf="isViewAll">
      <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
      <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate}} </span>
   </div>

   <ng-container *ngIf="!isViewAll">
      <app-position-out-config [elementChoosing]="objectChoosing" [device]="device" [id_parent_choose]="objectChoosing.id_block? objectChoosing.id_block: objectChoosing.id_object">
      </app-position-out-config>

      <app-width-height-config [device]="device" [elementChoosing]="objectChoosing" [width]="width" [height]="height" (changeWidthHeight)="changeWidthHeight($event)">
      </app-width-height-config>

      <ul nz-menu nzMode="inline">
         <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu1" (nzOpenChange)="openHandler('menu1')">
            <div class="button-size">
               <!-- Lựa chọn hiển thị cho các thiết bị -->
               <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
               </app-hide-show-config>
            </div>
         </li>
         <li nz-submenu nzTitle="{{ 'noi_dung' | translate }}" [(nzOpen)]="openMap.menu8" (nzOpenChange)="openHandler('menu8')">
            <div class="config-text" style="width: 100%" *ngFor="let section of sections">
               <p class="title mb-2" style="font-weight: 600; font-size: 13px;">
                  {{ section.title | translate }}
               </p>

               <mat-form-field style="width: 100%" *ngFor="let field of section.fields">
                  <mat-label>
                     {{ field.label | translate }}
                  </mat-label>

                  <textarea matInput [ngModel]="staticdata[field.model + '_' + functionService.selectedLanguageCode]| vhLanguage : field.model : objectChoosing.component" (ngModelChange)=" staticdata[field.model + '_' + functionService.selectedLanguageCode] = $event" (blur)="updateStaticData()">
                  </textarea>
               </mat-form-field>
            </div>
         </li>
         <!-- Cấu hình bố cục -->
          <li nz-submenu nzTitle="{{'bo_cuc' | translate}}" [(nzOpen)]="openMap.menu12" (nzOpenChange)="openHandler('menu12')">
            <div class="container-font">
              <!-- Hướng bố trí -->
              <div class="slide-bar mb-3">
                <p class="m-0 title w-50">{{'huong_bo_tri' | translate}}</p>
                <nz-radio-group [(ngModel)]="class['booking-selector']['flex-direction']" (ngModelChange)="updateClass()"
                  style="width: 50%">
                  <label nz-radio-button nzValue="row" nz-tooltip nzTooltipTitle="{{'ngang' | translate}}">
                    <i class="bi bi-arrow-right"></i>
                  </label>
                  <label nz-radio-button nzValue="column" nz-tooltip nzTooltipTitle="{{'doc' | translate}}">
                    <i class="bi bi-arrow-down"></i>
                  </label>
                  <!-- <label nz-radio-button nzValue="row-reverse" nz-tooltip nzTooltipTitle="{{'ngang_dao_nguoc' | translate}}">
                    <i class="bi bi-arrow-left"></i>
                  </label>
                  <label nz-radio-button nzValue="column-reverse" nz-tooltip nzTooltipTitle="{{'doc_dao_nguoc' | translate}}">
                    <i class="bi bi-arrow-up"></i>
                  </label> -->
                </nz-radio-group>
              </div>

              <!-- Căn chỉnh -->
              <div class="slide-bar mb-3">
                <p class="m-0 title w-50">{{'can_le' | translate}}</p>
                <nz-select [(ngModel)]="class['booking-selector']['align-items']" (ngModelChange)="updateClass()"
                  style="width: 50%">
                  <nz-option nzValue="flex-start" nzLabel="{{'dau' | translate}}"></nz-option>
                  <nz-option nzValue="center" nzLabel="{{'giua' | translate}}"></nz-option>
                  <nz-option nzValue="flex-end" nzLabel="{{'cuoi' | translate}}"></nz-option>
                </nz-select>
              </div>

              <!-- Khoảng cách (gap) -->
              <div class="slide-bar mt-2">
                <p class="m-0 title w-50">{{'khoang_cach' | translate}}</p>
                <nz-input-number [nzMin]="0" [nzMax]="100" style="width: 40%" [ngModel]="
                        class['booking-selector']['gap'] | vhnumber
                        " (nzBlur)="updateClass()" (ngModelChange)="
                        class['booking-selector']['gap'] =
                            $event + 'px'"></nz-input-number>
              </div>
            </div>
          </li>
          <li nz-submenu nzTitle="{{'khoang_dem' | translate}}" [(nzOpen)]="openMap.menu13"
            (nzOpenChange)="openHandler('menu13')">
            <!-- Khoảng đệm  -->
            <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
              [classPadding]="class['booking-selector']" [paddingConfigs]="[
                            { type: 'top' },
                            { type: 'bottom' },
                            { type: 'left' },
                            { type: 'right' }
                          ]">
            </app-padding-config>
          </li>
          <!-- Cấu hình màu nền -->
          <li nz-submenu nzTitle="{{'mau_nen' | translate}}" [(nzOpen)]="openMap.menu2" (nzOpenChange)="openHandler('menu2')">
           <div class="container-color">
             <button
               id="btn-color"
               *ngFor="let background of backgroundColor; let i = index"
               [ngStyle]="{ 'background-color': background.bgColor }"
               (click)="chooseBg(background, $event, 'booking-selector')"
               nz-tooltip [disabled]="config['background-color'].gradient_check"
            ></button>
           </div>
           <div class="color-pick mb-4">
             <span class="title w-50">{{'mau_nen' | translate}}</span>
             <input
               class="input-color w-50" type="button"
               [cpOKButton]="true" [(colorPicker)]="class['booking-selector']['background-color']"
               [style.background]="class['booking-selector']['background-color']"
               (colorPickerClose)="updateObject()"
               [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
               [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
               [cpPresetLabel]="'bang_mau_mau' | translate"
               [disabled]="config['background-color'].gradient_check"
               [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
               [cpPresetColors]="themeService.themeColors" (cpPresetColorsChange)="themeService.presetColorsChange($event)"
               (colorPickerOpen)="themeService.onPickerColorOpen($event)"
             />
           </div>
           <div class="mr-2 mb-4 mt-4 view-more" style="
               display: flex;
               align-items: center;
               justify-content: flex-end;
               gap: 7px;
             ">
             <p class="discover_text" (click)="openViewAll(styles_field[3])"
               style="cursor: pointer; text-align: left; margin: 0">
               {{'mau_gradient' | translate}} &#8594;
             </p>
           </div>
          </li>
          <!-- Kiểu viền -->
          <li nz-submenu nzTitle="{{'kieu_vien' | translate}}" [(nzOpen)]="openMap.menu3" (nzOpenChange)="openHandler('menu3')">
            <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderClass]="class['booking-selector']" [id_object]="objectChoosing._id">
            </app-borders-config>

            <!-- Nút mở rộng -->
            <div class="item-border my-3" style="float: right">
              <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[1])">
                {{'mo_rong' | translate}} &#8594;
              </p>
            </div>
          </li>

          <!-- Cấu hình đổ bóng -->
          <li nz-submenu nzTitle="{{'do_bong' | translate}}" [(nzOpen)]="openMap.menu4" (nzOpenChange)="openHandler('menu4')">
            <app-shadow-config [device]="device" [config]="config" [class]="class" [shadowClass]="class['booking-selector']" [shadowConfig]="config['box-shadow']" [objectChoosing]="objectChoosing">
            </app-shadow-config>
          </li>

          <!-- Cấu hình Chọn khách sạn -->
          <li nz-submenu nzTitle="{{'chon_khach_san' | translate}}" [(nzOpen)]="openMap.menu5" (nzOpenChange)="openHandler('menu5')">
            <ul class="submenu" nz-menu nzMode="inline" *ngIf="openMap.menu5">
              <li nz-submenu nzTitle="{{'dinh_dang_nhan' | translate}}">
                <div class="container-font">
                  <div class="config-text" style="width: 100%">
                    <app-text-format-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [config]="config"
                      [staticdata]="staticdata"
                      [textContentClass]="class['hotel-selector-input__label']"
                      [textWrapperClass]="class['hotel-selector-input__label']"
                      (changeTextAlignConfig)="changeWidthHeight({width: width})"
                    >
                    </app-text-format-config>
                    <!-- Khoảng cách chữ -->
                    <app-letter-spacing-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [classLetterSpacing]="class['hotel-selector-input__label']"
                      (updateClass)="updateClass()"
                    >
                    </app-letter-spacing-config>
                    <!-- Khoảng cách dòng -->
                    <app-line-height-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [classLineHeight]="class['hotel-selector-input__label']"
                      (updateClass)="updateClass()"
                    >
                    </app-line-height-config>
                  </div>
                </div>
              </li>
              <li nz-submenu nzTitle="{{'dinh_dang_gia_tri' | translate}}">
                <div class="container-font">
                  <div class="config-text" style="width: 100%">
                    <app-text-format-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [config]="config"
                      [staticdata]="staticdata"
                      [textContentClass]="class['hotel-selector-input__value']"
                      [textWrapperClass]="class['hotel-selector-input__value']"
                      (changeTextAlignConfig)="changeWidthHeight({width: width})"
                    >
                    </app-text-format-config>
                    <!-- Khoảng cách chữ -->
                    <app-letter-spacing-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [classLetterSpacing]="class['hotel-selector-input__value']"
                      (updateClass)="updateClass()"
                    >
                    </app-letter-spacing-config>
                    <!-- Khoảng cách dòng -->
                    <app-line-height-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [classLineHeight]="class['hotel-selector-input__value']"
                      (updateClass)="updateClass()"
                    >
                    </app-line-height-config>
                  </div>
                </div>
              </li>
              <!-- Màu nền -->
              <li nz-submenu nzTitle="{{'mau_nen' | translate}}">
                <div class="container-color">
                  <button
                    id="btn-color"
                    *ngFor="let background of backgroundColor; let i = index"
                    [ngStyle]="{ 'background-color': background.bgColor }"
                    (click)="chooseBg(background, $event, 'hotel-selector')"
                    nz-tooltip [disabled]="config['background-color'].gradient_check"
                  ></button>
                </div>
                <div class="color-pick mb-4">
                  <span class="title w-50">{{'mau_nen' | translate}}</span>
                  <input
                    class="input-color w-50" type="button"
                    [cpOKButton]="true" [(colorPicker)]="class['hotel-selector']['background-color']"
                    [style.background]="class['hotel-selector']['background-color']"
                    (colorPickerClose)="updateObject()"
                    [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                    [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                    [cpPresetLabel]="'bang_mau_mau' | translate"
                    [disabled]="config['background-color'].gradient_check"
                    [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                    [cpPresetColors]="themeService.themeColors" (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                    (colorPickerOpen)="themeService.onPickerColorOpen($event)"
                  />
                </div>
              </li>
              <!-- Kiểu viền -->
              <li nz-submenu nzTitle="{{'kieu_vien' | translate}}">
                <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderClass]="class['hotel-selector']" [id_object]="objectChoosing._id">
                </app-borders-config>

                <!-- Nút mở rộng -->
                <div class="item-border my-3" style="float: right">
                  <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[5])">
                    {{'mo_rong' | translate}} &#8594;
                  </p>
                </div>
              </li>
              <li nz-submenu nzTitle="{{'khoang_dem' | translate}}">
                <!-- Khoảng đệm  -->
                <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                  [classPadding]="class['hotel-selector']" [paddingConfigs]="[
                  { type: 'top' },
                  { type: 'bottom' },
                  { type: 'left' },
                  { type: 'right' }
                ]">
                </app-padding-config>
              </li>
              <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}">
                <div class="space-middle">
                  <div class="item-symbol">
                    <p class="title" style="line-height: 1.5">{{'su_dung' | translate}}</p>
                    <nz-switch [(ngModel)]="config.icon_hotel_selector.icon_disable" (ngModelChange)="updateConfig()"></nz-switch>
                  </div>
                  <div class="d-flex justify-content-between mx-1">
                    <mat-icon>{{ config.icon_hotel_selector.icon_name }}</mat-icon>
                    <button nz-button nzType="default" (click)="openDialogChooseIcon(config.icon_hotel_selector)" style="border-radius: 5px"
                      [disabled]="!config.icon_hotel_selector.icon_disable">
                      {{'thay_doi' | translate}}
                    </button>
                  </div>
                  <div class="slide-bar">
                    <p class="m-0 title w-50">{{'mau_sac_icon' | translate}}</p>
                    <input style="width: 50%; height:30px" class="input-color" type="button"
                      [cpOKButton]="true"
                      [(colorPicker)]="class['hotel-selector-icon'].color"
                      [style.background]="class['hotel-selector-icon'].color"
                      (colorPickerClose)="updateClass()"
                      [cpWidth]="'230px'"
                      [cpMaxPresetColorsLength]="functionService.cpMaxPresetColorsLength"
                      [cpAddColorButton]="true"
                      [cpAddColorButtonText]="'them_mau' | translate"
                      [cpPresetLabel]="'bang_mau_mau' | translate"
                      [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                      [cpPresetColors]="functionService.themeColors"
                      (cpPresetColorsChange)="functionService.presetColorsChange($event)"
                    />
                  </div>
                  <div class="slide-bar mt-2">
                    <p class="m-0 title">{{'kich_thuoc_icon' | translate}}</p>
                    <nz-input-number [nzMin]="10" [nzMax]="100" style="width: 40%" [ngModel]="
                            class['hotel-selector-icon']['font-size'] | vhnumber
                            " (nzBlur)="updateClass()" (ngModelChange)="
                            class['hotel-selector-icon']['font-size'] =
                                $event + 'px'"></nz-input-number>
                  </div>
                </div>
              </li>
            </ul>
          </li>
          <!-- Cấu hình Chọn ngày nhận trả phòng -->
          <li nz-submenu nzTitle="{{'chon_ngay_nhan_tra_phong' | translate}}" [(nzOpen)]="openMap.menu6" (nzOpenChange)="openHandler('menu6')">
            <ul class="submenu" nz-menu nzMode="inline" *ngIf="openMap.menu6">
              <li nz-submenu nzTitle="{{'dinh_dang_nhan' | translate}}">
                <div class="container-font">
                  <div class="config-text" style="width: 100%">
                    <app-text-format-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [config]="config"
                      [staticdata]="staticdata"
                      [textContentClass]="class['departure-date-input__label']"
                      [textWrapperClass]="class['departure-date-input__label']"
                      (changeTextAlignConfig)="changeWidthHeight({width: width})"
                    >
                    </app-text-format-config>
                    <!-- Khoảng cách chữ -->
                    <app-letter-spacing-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [classLetterSpacing]="class['departure-date-input__label']"
                      (updateClass)="updateClass()"
                    >
                    </app-letter-spacing-config>
                    <!-- Khoảng cách dòng -->
                    <app-line-height-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [classLineHeight]="class['departure-date-input__label']"
                      (updateClass)="updateClass()"
                    >
                    </app-line-height-config>
                  </div>
                </div>
              </li>
              <li nz-submenu nzTitle="{{'dinh_dang_gia_tri' | translate}}">
                <div class="container-font">
                  <div class="config-text" style="width: 100%">
                    <app-text-format-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [config]="config"
                      [staticdata]="staticdata"
                      [textContentClass]="class['departure-date-input__value']"
                      [textWrapperClass]="class['departure-date-input__value']"
                      (changeTextAlignConfig)="changeWidthHeight({width: width})"
                    >
                    </app-text-format-config>
                    <!-- Khoảng cách chữ -->
                    <app-letter-spacing-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [classLetterSpacing]="class['departure-date-input__value']"
                      (updateClass)="updateClass()"
                    >
                    </app-letter-spacing-config>
                    <!-- Khoảng cách dòng -->
                    <app-line-height-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [classLineHeight]="class['departure-date-input__value']"
                      (updateClass)="updateClass()"
                    >
                    </app-line-height-config>
                  </div>
                </div>
              </li>
              <!-- Màu nền -->
              <li nz-submenu nzTitle="{{'mau_nen' | translate}}">
                <div class="container-color">
                  <button
                    id="btn-color"
                    *ngFor="let background of backgroundColor; let i = index"
                    [ngStyle]="{ 'background-color': background.bgColor }"
                    (click)="chooseBg(background, $event, 'departure-date')"
                    nz-tooltip [disabled]="config['background-color'].gradient_check"
                  ></button>
                </div>
                <div class="color-pick mb-4">
                  <span class="title w-50">{{'mau_nen' | translate}}</span>
                  <input
                    class="input-color w-50" type="button"
                    [cpOKButton]="true" [(colorPicker)]="class['departure-date']['background-color']"
                    [style.background]="class['departure-date']['background-color']"
                    (colorPickerClose)="updateObject()"
                    [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                    [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                    [cpPresetLabel]="'bang_mau_mau' | translate"
                    [disabled]="config['background-color'].gradient_check"
                    [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                    [cpPresetColors]="themeService.themeColors" (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                    (colorPickerOpen)="themeService.onPickerColorOpen($event)"
                  />
                </div>
              </li>
              <!-- Kiểu viền -->
              <li nz-submenu nzTitle="{{'kieu_vien' | translate}}">
                <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderClass]="class['departure-date']" [id_object]="objectChoosing._id">
                </app-borders-config>

                <!-- Nút mở rộng -->
                <div class="item-border my-3" style="float: right">
                  <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[6])">
                    {{'mo_rong' | translate}} &#8594;
                  </p>
                </div>
              </li>
              <li nz-submenu nzTitle="{{'khoang_dem' | translate}}">
                <!-- Khoảng đệm  -->
                <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                  [classPadding]="class['departure-date']" [paddingConfigs]="[
                  { type: 'top' },
                  { type: 'bottom' },
                  { type: 'left' },
                  { type: 'right' }
                ]">
                </app-padding-config>
              </li>
              <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}">
                <div class="space-middle">
                  <div class="item-symbol">
                    <p class="title" style="line-height: 1.5">{{'su_dung' | translate}}</p>
                    <nz-switch [(ngModel)]="config.icon_departure_date.icon_disable" (ngModelChange)="updateConfig()"></nz-switch>
                  </div>
                  <div class="d-flex justify-content-between mx-1">
                    <mat-icon>{{ config.icon_departure_date.icon_name }}</mat-icon>
                    <button nz-button nzType="default" (click)="openDialogChooseIcon(config.icon_departure_date)" style="border-radius: 5px"
                      [disabled]="!config.icon_departure_date.icon_disable">
                      {{'thay_doi' | translate}}
                    </button>
                  </div>
                  <div class="slide-bar">
                    <p class="m-0 title w-50">{{'mau_sac_icon' | translate}}</p>
                    <input style="width: 50%; height:30px" class="input-color" type="button"
                      [cpOKButton]="true"
                      [(colorPicker)]="class['departure-date-icon'].color"
                      [style.background]="class['departure-date-icon'].color"
                      (colorPickerClose)="updateClass()"
                      [cpWidth]="'230px'"
                      [cpMaxPresetColorsLength]="functionService.cpMaxPresetColorsLength"
                      [cpAddColorButton]="true"
                      [cpAddColorButtonText]="'them_mau' | translate"
                      [cpPresetLabel]="'bang_mau_mau' | translate"
                      [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                      [cpPresetColors]="functionService.themeColors"
                      (cpPresetColorsChange)="functionService.presetColorsChange($event)"
                    />
                  </div>
                  <div class="slide-bar mt-2">
                    <p class="m-0 title">{{'kich_thuoc_icon' | translate}}</p>
                    <nz-input-number [nzMin]="10" [nzMax]="100" style="width: 40%" [ngModel]="
                            class['departure-date-icon']['font-size'] | vhnumber
                            " (nzBlur)="updateClass()" (ngModelChange)="
                            class['departure-date-icon']['font-size'] =
                                $event + 'px'"></nz-input-number>
                  </div>
                </div>
              </li>
            </ul>
          </li>
          <li nz-submenu nzTitle="{{'chon_so_phong_khach' | translate}}" [(nzOpen)]="openMap.menu7" (nzOpenChange)="openHandler('menu7')">
            <ul class="submenu" nz-menu nzMode="inline" *ngIf="openMap.menu7">
              <li nz-submenu nzTitle="{{'dinh_dang_nhan' | translate}}">
                <div class="container-font">
                  <div class="config-text" style="width: 100%">
                    <app-text-format-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [config]="config"
                      [staticdata]="staticdata"
                      [textContentClass]="class['guest-selector-input__label']"
                      [textWrapperClass]="class['guest-selector-input__label']"
                      (changeTextAlignConfig)="changeWidthHeight({width: width})"
                    >
                    </app-text-format-config>
                    <!-- Khoảng cách chữ -->
                    <app-letter-spacing-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [classLetterSpacing]="class['guest-selector-input__label']"
                      (updateClass)="updateClass()"
                    >
                    </app-letter-spacing-config>
                    <!-- Khoảng cách dòng -->
                    <app-line-height-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [classLineHeight]="class['guest-selector-input__label']"
                      (updateClass)="updateClass()"
                    >
                    </app-line-height-config>
                  </div>
                </div>
              </li>
              <li nz-submenu nzTitle="{{'dinh_dang_gia_tri' | translate}}">
                <div class="container-font">
                  <div class="config-text" style="width: 100%">
                    <app-text-format-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [config]="config"
                      [staticdata]="staticdata"
                      [textContentClass]="class['guest-selector-input__value']"
                      [textWrapperClass]="class['guest-selector-input__value']"
                      (changeTextAlignConfig)="changeWidthHeight({width: width})"
                    >
                    </app-text-format-config>
                    <!-- Khoảng cách chữ -->
                    <app-letter-spacing-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [classLetterSpacing]="class['guest-selector-input__value']"
                      (updateClass)="updateClass()"
                    >
                    </app-letter-spacing-config>
                    <!-- Khoảng cách dòng -->
                    <app-line-height-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [classLineHeight]="class['guest-selector-input__value']"
                      (updateClass)="updateClass()"
                    >
                    </app-line-height-config>
                  </div>
                </div>
              </li>
              <!-- Màu nền -->
              <li nz-submenu nzTitle="{{'mau_nen' | translate}}">
                <div class="container-color">
                  <button
                    id="btn-color"
                    *ngFor="let background of backgroundColor; let i = index"
                    [ngStyle]="{ 'background-color': background.bgColor }"
                    (click)="chooseBg(background, $event, 'guest-selector')"
                    nz-tooltip [disabled]="config['background-color'].gradient_check"
                  ></button>
                </div>
                <div class="color-pick mb-4">
                  <span class="title w-50">{{'mau_nen' | translate}}</span>
                  <input
                    class="input-color w-50" type="button"
                    [cpOKButton]="true" [(colorPicker)]="class['guest-selector']['background-color']"
                    [style.background]="class['guest-selector']['background-color']"
                    (colorPickerClose)="updateObject()"
                    [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                    [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                    [cpPresetLabel]="'bang_mau_mau' | translate"
                    [disabled]="config['background-color'].gradient_check"
                    [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                    [cpPresetColors]="themeService.themeColors" (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                    (colorPickerOpen)="themeService.onPickerColorOpen($event)"
                  />
                </div>
              </li>
              <!-- Kiểu viền -->
              <li nz-submenu nzTitle="{{'kieu_vien' | translate}}">
                <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderClass]="class['guest-selector']" [id_object]="objectChoosing._id">
                </app-borders-config>

                <!-- Nút mở rộng -->
                <div class="item-border my-3" style="float: right">
                  <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[7])">
                    {{'mo_rong' | translate}} &#8594;
                  </p>
                </div>
              </li>
              <li nz-submenu nzTitle="{{'khoang_dem' | translate}}">
                <!-- Khoảng đệm  -->
                <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                  [classPadding]="class['guest-selector']" [paddingConfigs]="[
                  { type: 'top' },
                  { type: 'bottom' },
                  { type: 'left' },
                  { type: 'right' }
                ]">
                </app-padding-config>
              </li>
              <!-- Biểu tượng -->
              <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}">
                <div class="space-middle">
                  <div class="item-symbol">
                    <p class="title" style="line-height: 1.5">{{'su_dung' | translate}}</p>
                    <nz-switch [(ngModel)]="config.icon_guest_selector.icon_disable" (ngModelChange)="updateConfig()"></nz-switch>
                  </div>
                  <div class="d-flex justify-content-between mx-1">
                    <mat-icon>{{ config.icon_guest_selector.icon_name }}</mat-icon>
                    <button nz-button nzType="default" (click)="openDialogChooseIcon(config.icon_guest_selector)" style="border-radius: 5px"
                      [disabled]="!config.icon_guest_selector.icon_disable">
                      {{'thay_doi' | translate}}
                    </button>
                  </div>
                  <div class="slide-bar">
                    <p class="m-0 title w-50">{{'mau_sac_icon' | translate}}</p>
                    <input style="width: 50%; height:30px" class="input-color" type="button"
                      [cpOKButton]="true"
                      [(colorPicker)]="class['guest-selector-icon'].color"
                      [style.background]="class['guest-selector-icon'].color"
                      (colorPickerClose)="updateClass()"
                      [cpWidth]="'230px'"
                      [cpMaxPresetColorsLength]="functionService.cpMaxPresetColorsLength"
                      [cpAddColorButton]="true"
                      [cpAddColorButtonText]="'them_mau' | translate"
                      [cpPresetLabel]="'bang_mau_mau' | translate"
                      [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                      [cpPresetColors]="functionService.themeColors"
                      (cpPresetColorsChange)="functionService.presetColorsChange($event)"
                    />
                  </div>
                  <div class="slide-bar mt-2">
                    <p class="m-0 title">{{'kich_thuoc_icon' | translate}}</p>
                    <nz-input-number [nzMin]="10" [nzMax]="100" style="width: 40%" [ngModel]="
                            class['guest-selector-icon']['font-size'] | vhnumber
                            " (nzBlur)="updateClass()" (ngModelChange)="
                            class['guest-selector-icon']['font-size'] =
                                $event + 'px'"></nz-input-number>
                  </div>
                </div>
              </li>
            </ul>
          </li>

          <li nz-submenu [nzTitle]="'cau_hinh_lich' | translate" [(nzOpen)]="openMap.menu9" (nzOpenChange)="openHandler('menu9')">
            <div class="container-font" *ngIf="openMap.menu9">
              <div class="color-pick mb-4">
                <span class="title w-50">{{'mau_chu_chon_ngay' | translate}}</span>
                <input
                  class="input-color w-50" type="button"
                  [cpOKButton]="true" [(colorPicker)]="config['range-picker']['color-text']"
                  [style.background]="config['range-picker']['color-text']"
                  (colorPickerClose)="updateConfig()"
                  [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                  [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                  [cpPresetLabel]="'bang_mau_mau' | translate"
                  [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                  [cpPresetColors]="themeService.themeColors" (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                  (colorPickerOpen)="themeService.onPickerColorOpen($event)"
                />
              </div>
              <div class="color-pick mb-4">
                <span class="title w-50">{{'mau_khi_chon_ngay' | translate}}</span>
                <input
                  class="input-color w-50" type="button"
                  [cpOKButton]="true" [(colorPicker)]="config['range-picker']['primary-color']"
                  [style.background]="config['range-picker']['primary-color']"
                  (colorPickerClose)="updateConfig()"
                  [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                  [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                  [cpPresetLabel]="'bang_mau_mau' | translate"
                  [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                  [cpPresetColors]="themeService.themeColors" (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                  (colorPickerOpen)="themeService.onPickerColorOpen($event)"
                />
              </div>
            </div>
          </li>

          <li nz-submenu [nzTitle]="'cau_hinh_hop_thoai_phong' | translate" [(nzOpen)]="openMap.menu10" (nzOpenChange)="openHandler('menu10')">
            <ul class="submenu" nz-menu nzMode="inline" *ngIf="openMap.menu10">
              <li nz-submenu [nzTitle]="'hop_thoai' | translate">
                <div class="container-font">
                  <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderClass]="class['room-popover']" [id_object]="objectChoosing._id">
                  </app-borders-config>
                  <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                    [classPadding]="class['room-popover']" [paddingConfigs]="[
                    { type: 'top' },
                    { type: 'bottom' },
                    { type: 'left' },
                    { type: 'right' }
                  ]">
                  </app-padding-config>
                  <div class="color-pick mb-4">
                    <span class="title w-50">{{'mau_nen' | translate}}</span>
                    <input
                      class="input-color w-50" type="button"
                      [cpOKButton]="true" [(colorPicker)]="class['room-popover']['background-color']"
                      [style.background]="class['room-popover']['background-color']"
                      (colorPickerClose)="updateClass()"
                      [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                      [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                      [cpPresetLabel]="'bang_mau_mau' | translate"
                      [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                      [cpPresetColors]="themeService.themeColors" (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                      (colorPickerOpen)="themeService.onPickerColorOpen($event)"
                    />
                  </div>
                </div>
              </li>
              <li nz-submenu [nzTitle]="'van_ban' | translate" [(nzOpen)]="openMapSub.menu1" (nzOpenChange)="openHandler('menu1', true)">
                <ul class="submenu__sub" nz-menu nzMode="inline" *ngIf="openMapSub.menu1">
                  <li nz-submenu [nzTitle]="'tieu_de' | translate">
                    <app-text-format-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [config]="config"
                      [staticdata]="staticdata"
                      [textContentClass]="class['room-popover__header']"
                      [textWrapperClass]="class['room-popover__header']"
                    >
                    </app-text-format-config>
                  </li>
                  <li nz-submenu [nzTitle]="'tieu_de_phong' | translate">
                    <app-text-format-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [config]="config"
                      [staticdata]="staticdata"
                      [textContentClass]="class['room-popover__room-title']"
                      [textWrapperClass]="class['room-popover__room-title']"
                    >
                    </app-text-format-config>
                  </li>
                  <li nz-submenu [nzTitle]="'nhan' | translate">
                    <app-text-format-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [config]="config"
                      [staticdata]="staticdata"
                      [textContentClass]="class['room-popover__label']"
                      [textWrapperClass]="class['room-popover__label']"
                    >
                    </app-text-format-config>
                  </li>
                  <li nz-submenu [nzTitle]="'gia_tri' | translate">
                    <app-text-format-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [config]="config"
                      [staticdata]="staticdata"
                      [textContentClass]="class['room-popover__value']"
                      [textWrapperClass]="class['room-popover__value']"
                    >
                    </app-text-format-config>
                  </li>
                </ul>
              </li>
              <li nz-submenu [nzTitle]="'bo_dem' | translate" [(nzOpen)]="openMapSub.menu2" (nzOpenChange)="openHandler('menu2', true)">
                <div class="submenu__sub container-font" *ngIf="openMapSub.menu2">
                  <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderClass]="class['room-popover__counter-button']" [id_object]="objectChoosing._id">
                  </app-borders-config>
                  <div class="color-pick mb-4">
                    <span class="title w-50">{{'nen_nut' | translate}}</span>
                    <input
                      class="input-color w-50" type="button"
                      [cpOKButton]="true" [(colorPicker)]="class['room-popover__counter-button']['background-color']"
                      [style.background]="class['room-popover__counter-button']['background-color']"
                      (colorPickerClose)="updateClass()"
                      [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                      [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                      [cpPresetLabel]="'bang_mau_mau' | translate"
                      [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                      [cpPresetColors]="themeService.themeColors" (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                      (colorPickerOpen)="themeService.onPickerColorOpen($event)"
                    />
                  </div>
                  <div class="slide-bar mt-2">
                    <p class="m-0 title">{{'kich_thuoc_nut' | translate}}</p>
                    <nz-input-number [nzMin]="20" [nzMax]="80" style="width: 40%" [ngModel]="class['room-popover__counter-button']['width'] | vhnumber"
                      (nzBlur)="updateClass()" (ngModelChange)="class['room-popover__counter-button']['width'] = $event + 'px'; class['room-popover__counter-button']['height'] = $event + 'px'"></nz-input-number>
                  </div>
                  <div class="slide-bar">
                    <p class="m-0 title w-50">{{'mau_sac_icon' | translate}}</p>
                    <input style="width: 50%; height:30px" class="input-color" type="button"
                      [cpOKButton]="true"
                      [(colorPicker)]="class['room-popover__counter-icon'].color"
                      [style.background]="class['room-popover__counter-icon'].color"
                      (colorPickerClose)="updateClass()"
                      [cpWidth]="'230px'"
                      [cpMaxPresetColorsLength]="functionService.cpMaxPresetColorsLength"
                      [cpAddColorButton]="true"
                      [cpAddColorButtonText]="'them_mau' | translate"
                      [cpPresetLabel]="'bang_mau_mau' | translate"
                      [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                      [cpPresetColors]="functionService.themeColors"
                      (cpPresetColorsChange)="functionService.presetColorsChange($event)"
                    />
                  </div>
                  <div class="slide-bar mt-2">
                    <p class="m-0 title">{{'kich_thuoc_icon' | translate}}</p>
                    <nz-input-number [nzMin]="10" [nzMax]="100" style="width: 40%" [ngModel]="
                            class['room-popover__counter-icon']['font-size'] | vhnumber
                            " (nzBlur)="updateClass()" (ngModelChange)="
                            class['room-popover__counter-icon']['font-size'] =
                                $event + 'px'"></nz-input-number>
                  </div>
                </div>
              </li>
            </ul>
          </li>

          <li nz-submenu nzTitle="{{'nut_tim_kiem' | translate}}" [(nzOpen)]="openMap.menu11" (nzOpenChange)="openHandler('menu11')">
            <ul class="submenu" nz-menu nzMode="inline" *ngIf="openMap.menu11">
              <li nz-submenu nzTitle="{{'dinh_dang' | translate}}">
                <div class="container-font">
                  <div class="config-text" style="width: 100%">
                    <app-text-format-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [config]="config"
                      [staticdata]="staticdata"
                      [textContentClass]="class['btn-search__label']"
                      [textWrapperClass]="class['btn-search__label']"
                      (changeTextAlignConfig)="changeWidthHeight({width: width})"
                    >
                    </app-text-format-config>
                    <!-- Khoảng cách chữ -->
                    <app-letter-spacing-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [classLetterSpacing]="class['btn-search__label']"
                      (updateClass)="updateClass()"
                    >
                    </app-letter-spacing-config>
                    <!-- Khoảng cách dòng -->
                    <app-line-height-config
                      [objectChoosing]="objectChoosing"
                      [device]="device"
                      [class]="class"
                      [classLineHeight]="class['btn-search__label']"
                      (updateClass)="updateClass()"
                    >
                    </app-line-height-config>
                  </div>
                </div>
              </li>
              <!-- Màu nền -->
              <li nz-submenu nzTitle="{{'mau_nen' | translate}}">
                <div class="container-color">
                  <button
                    id="btn-color"
                    *ngFor="let background of backgroundColor; let i = index"
                    [ngStyle]="{ 'background-color': background.bgColor }"
                    (click)="chooseBg(background, $event, 'btn-search')"
                    nz-tooltip [disabled]="config['background-color'].gradient_check"
                  ></button>
                </div>
                <div class="color-pick mb-4">
                  <span class="title w-50">{{'mau_nen' | translate}}</span>
                  <input
                    class="input-color w-50" type="button"
                    [cpOKButton]="true" [(colorPicker)]="class['btn-search']['background-color']"
                    [style.background]="class['btn-search']['background-color']"
                    (colorPickerClose)="updateObject()"
                    [cpWidth]="'230px'" [cpMaxPresetColorsLength]="themeService.cpMaxPresetColorsLength"
                    [cpAddColorButton]="true" [cpAddColorButtonText]="'them_mau' | translate"
                    [cpPresetLabel]="'bang_mau_mau' | translate"
                    [disabled]="config['background-color'].gradient_check"
                    [cpPresetEmptyMessage]="'chua_co_mau_nao_duoc_them' | translate"
                    [cpPresetColors]="themeService.themeColors" (cpPresetColorsChange)="themeService.presetColorsChange($event)"
                    (colorPickerOpen)="themeService.onPickerColorOpen($event)"
                  />
                </div>
              </li>
              <!-- Kiểu viền -->
              <li nz-submenu nzTitle="{{'kieu_vien' | translate}}">
                <app-borders-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderClass]="class['btn-search']" [id_object]="objectChoosing._id">
                </app-borders-config>

                <!-- Nút mở rộng -->
                <div class="item-border my-3" style="float: right">
                  <p class="m-0 title-border my-2" (click)="openViewAll(styles_field[8])">
                    {{'mo_rong' | translate}} &#8594;
                  </p>
                </div>
              </li>
              <li nz-submenu nzTitle="{{'khoang_dem' | translate}}">
                <!-- Khoảng đệm  -->
                <app-padding-config [objectChoosing]="objectChoosing" [device]="device" [class]="class"
                  [classPadding]="class['btn-search']" [paddingConfigs]="[
                  { type: 'top' },
                  { type: 'bottom' },
                  { type: 'left' },
                  { type: 'right' }
                ]">
                </app-padding-config>
              </li>
              <li nz-submenu nzTitle="{{'bieu_tuong' | translate}}">
                <app-symbol-config [device]="device" [class]="class" [config]="config" [symbolClass]="class['btn-search']"
                  [fontSizeIconClass]="class['btn-search__icon']" [symbolConfig]="config['icon_btn_search']"
                  [objectChoosing]="objectChoosing">
                </app-symbol-config>
              </li>
              <!-- Hình ảnh -->
              <li nz-submenu nzTitle="{{'kich_thuoc' | translate}}">
                <div>
                  <div style="flex-direction: column; gap: 12px;" class="config-name">
                    <div class="slide-bar">
                      <p class="m-0 title">{{'chieu_rong' | translate}}</p>
                      <nz-input-number [nzMin]="0" style="width: 40%" [ngModel]="
                          class['btn-search']['width'] | vhnumber
                          " (nzBlur)="updateClass()" (ngModelChange)="
                          class['btn-search']['width'] =
                          $event + 'px'"></nz-input-number>
                    </div>
                    <div class="slide-bar">
                      <p class="m-0 title">{{'chieu_cao' | translate}}</p>
                      <nz-input-number [nzMin]="0" style="width: 40%" [ngModel]="
                          class['btn-search']['height'] | vhnumber
                          " (nzBlur)="updateClass()" (ngModelChange)="
                          class['btn-search']['height'] =
                          $event + 'px'"></nz-input-number>
                    </div>
                  </div>
                </div>
               </li>
               <!-- Cấu hình thêm liên kết -->
              <li nz-submenu nzTitle="{{'lien_ket' | translate}}">
                <app-link-page-config [objectChoosing]="objectChoosing" [type_page]="['blank', 'homepage', 'detail_product']"
                  [staticdata]="staticdata" [id_object]="objectChoosing._id" [blocks_of_page]="blocks_of_page"></app-link-page-config>
              </li>
            </ul>
          </li>
      </ul>
   </ng-container>

   <!-- Xem chi tiết cấu hình object -->
   <div class="view-more" *ngIf="isViewAll">
     <!-- Cấu hình chi tiết viền -->
     <div class="view_more-border" *ngIf="currentViewAll.index == 2">
       <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderRadiusClass]="class['booking-selector']" [id_object]="objectChoosing._id">
       </app-borders-radius-config>
     </div>

     <div class="view_more-border" *ngIf="currentViewAll.index == 6">
       <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderRadiusClass]="class['hotel-selector']" [id_object]="objectChoosing._id">
       </app-borders-radius-config>
     </div>

     <div class="view_more-border" *ngIf="currentViewAll.index == 7">
       <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderRadiusClass]="class['departure-date']" [id_object]="objectChoosing._id">
       </app-borders-radius-config>
     </div>
     
     <div class="view_more-border" *ngIf="currentViewAll.index == 8">
       <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderRadiusClass]="class['guest-selector']" [id_object]="objectChoosing._id">
       </app-borders-radius-config>
     </div>

     <div class="view_more-border" *ngIf="currentViewAll.index == 9">
       <app-borders-radius-config [elementChoosing]="objectChoosing" [device]="device" [class]="class" [borderRadiusClass]="class['btn-search']" [id_object]="objectChoosing._id">
       </app-borders-radius-config>
     </div>

     <!-- Cấu hình chi tiết hiệu ứng -->
     <div class="editor_effect-hover" *ngIf="currentViewAll.index == 3">
       <app-animations-config [elementChoosing]="objectChoosing" [staticdata]="staticdata" [id_object]="objectChoosing._id" [customize]="customize" [device]="device"></app-animations-config>
     </div>

     <!-- Cấu hình chi tiết màu gradient  -->
     <div class="container-gradient" *ngIf="currentViewAll.index == 4">
       <div class="title-head">
         <p class="text-fill">{{'phoi_mau' | translate}}</p>
         <label nz-checkbox [(ngModel)]="config['background-color'].gradient_check" (ngModelChange)="updateBackgroundRgb()"></label>
       </div>
       <div class="list-gradient">
         <button class="btn-gradient" *ngFor="
             let bgGradient of config['background-color']['gradient_arr'];
             let i = index
           " (click)="deleteGradient(i)" [ngStyle]="{ 'background-color': bgGradient }" [disabled]="!config['background-color'].gradient_check">
           <i class="delete-icon bi bi-x-circle"></i>
         </button>
       </div>
       <p class="title-head">{{'them_mau' | translate}}</p>
       <div class="container_add-gradient">
         <input class="input-color" [cpOKButton]="true" [(colorPicker)]="config['background-color'].background" type="button" [disabled]="!config['background-color'].gradient_check" [style.background]="config['background-color'].background" (colorPickerClose)="addGradient($event)" />
       </div>
       <p class="title-head">{{'huong_phoi_mau' | translate}}</p>
       <button class="gradient-direction" *ngFor="let type of functionService.gradientDirectionList" nz-tooltip nzTooltipTitle="{{type.name | translate}}" (click)="chooseOption(type, $event)" [disabled]="!config['background-color'].gradient_check" [style.background]="'linear-gradient(' + type.deg + ', #2764EB, #EFE810)'" [class.active]="config['background-color'].gradient_direction === type.direction">
       </button>
     </div>
   </div>
</div>
